import React, { useState, useRef, useEffect } from 'react';
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';
import styled from 'styled-components';
import Icon, { Icons } from '../components/Icon';
import Button from '../components/Button';

const Croper = styled.div`
  width: 100%;
  position: relative;
`;
const RemoveIconDiv = styled.div`
  display: block;
  border-radius: 50%;
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 500;
  cursor: pointer;
`;

const ReCropper = ({ img, reset, setFileData }) => {
  const [cropper, setCropper] = useState(null);
  const imageRef = useRef(null);

  useEffect(() => {
    // Create URL
    let src;
    if (imageRef.current && img) {
      src = window.URL.createObjectURL(img);
      imageRef.current.src = src;
      const cropperjs = new Cropper(imageRef.current, {
        // aspectRatio: 1,
        viewMode: 1,
        responsive: true,
        center: true,
        ready: () => {
          console.log('cropper ready');
        },
        crop: () => {
          // console.log(e.detail);
        },
      });
      setCropper(cropperjs);
    }
    return () => {
      window.URL.revokeObjectURL(src);
    };
  }, [img, imageRef]);

  const buildURL = () => {
    const canvas = cropper.getCroppedCanvas();
    canvas.toBlob((blob) => {
      setFileData(blob);
    });
    cropper.destroy();
  };

  return (
    <>
      <Croper className="re-cropper">
        <RemoveIconDiv>
          <Icon
            icon={Icons.TimesCircleSolid}
            inactiveColor="red"
            onClick={() => reset()}
            size={15}
          />
        </RemoveIconDiv>
        <img
          ref={imageRef}
          alt="Cropping"
          style={{ width: '100%', maxHeight: '500px' }}
        />
      </Croper>
      <Button
        margin="10px 0px 0px 0px"
        text="CROP"
        type="button"
        minWidth="100px"
        width="10%"
        onClick={buildURL}
      />
    </>
  );
};

export default ReCropper;
